import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import NotFound from 'apps/promo/components/NotFound';
import RedirectComponent from 'apps/promo/components/utils/RedirectComponent';
import landing from 'apps/promo/routes/landingNew';

const PromoApp = ({ routes = [], redirectTo, data }) => {
    return (
        <Routes>
            {routes.map(({ path, exact, component: Component, stateOptions, renderOptions }) => {
                const isRedirect = redirectTo && redirectTo !== path;
                return (
                    <Route
                        key={path}
                        path={path}
                        exact={exact}
                        element={
                            isRedirect ? (
                                <Navigate to={redirectTo} />
                            ) : (
                                <Component reloadData={isRedirect} renderOptions={renderOptions} stateOptions={stateOptions} data={data} />
                            )
                        }
                    />
                );
            })}
            {landing.map(({ path, exact }) => {
                if (Array.isArray(path)) {
                    return path.map((p) => <Route key={p} path={p} exact={exact} element={<RedirectComponent key={p} />} />);
                }
                return <Route key={path} path={path} exact={exact} element={<RedirectComponent />} />;
            })}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default PromoApp;
